module.exports = __webpack_public_path__ + "img/31.a2b61011.jpg";